const borderRadii = {
  default: "10px",
  medium: "12.5px",
  big: "25px",
  focusWell: "200px"
};

export { borderRadii };
